import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <section id="categorie" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-foreground-400 mb-3 block">
            Esplora
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            Seleziona Categoria
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Scegli una categoria per esplorare i prodotti disponibili su Itaobuy Spreadsheet
          </p>
        </div>

        <div className="flex justify-center mb-12">
          <div ref={dropdownRef} className="relative w-full max-w-md">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="w-full flex items-center justify-between bg-white border border-background-200/70 rounded-xl px-5 py-3.5 text-foreground-800 hover:border-primary-300 transition-all cursor-pointer"
            >
              <span className="text-sm font-medium">
                {selectedCategory || 'Scegli una categoria...'}
              </span>
              <i className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
            </button>

            {isOpen && (
              <div className="absolute top-full mt-2 w-full bg-white border border-background-200/70 rounded-xl shadow-lg z-30 max-h-80 overflow-y-auto">
                {categories.map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.link}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => {
                      setSelectedCategory(cat.nameIt);
                      setIsOpen(false);
                    }}
                    className="flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <span className="w-8 h-8 flex items-center justify-center text-primary-500">
                      <i className={`${cat.icon} text-base`}></i>
                    </span>
                    {cat.nameIt}
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.link}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-white rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`Itaobuy Spreadsheet ${cat.nameIt}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 md:p-4">
                <span className="w-7 h-7 flex items-center justify-center text-primary-500 mb-1.5">
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{cat.nameIt}</h3>
                <p className="text-xs text-foreground-400 mt-0.5">{cat.nameEn}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}